import { makeAutoObservable } from "mobx";
import FirebaseService from "./FirebaseService";
import { and, collection, doc, getDoc, getDocs, limit, or, orderBy, query, setDoc, where } from "firebase/firestore";

export const paymentUrl = "https://processpayment-7dno2wbsya-uc.a.run.app";
export const verifyPaymentUrl = "https://verifypayment-7dno2wbsya-uc.a.run.app";
const functionsBaseUrl = process.env.REACT_APP_FUNCTIONS_BASE_URL || "https://us-central1-trail-tools.cloudfunctions.net";
export const cancelSubscriptionUrl = `${functionsBaseUrl}/cancelSubscription`;

export default class OrdersService {

    private _firebaseService: FirebaseService;
    private _mostRecentOrder: { id_plan: string; createdAt: Date } | null = null;
    private _subscriptionType: "lifetime" | "monthly" | "annual" | "special" | null = null;

    get mostRecentOrder() {
        return this._mostRecentOrder;
    }

    get subscriptionType() {
        return this._subscriptionType;
    }

    constructor(firebaseService: FirebaseService) {

        this._firebaseService = firebaseService;
        makeAutoObservable(this, undefined, { autoBind: true, deep: false })
    }

    async orderExists(userId: string, orderNumber: string): Promise<boolean | "error"> {

        const db = this._firebaseService.db;
        const docRef = doc(db, `orders/${userId}-${orderNumber}`);
        return getDoc(docRef).then((docSnapshot) => {
            return docSnapshot.exists();
        }).catch(() => {
            return "error";
        });
    };

    async upsertOrder(userId: string, orderNumber: string, email: string = ""): Promise<void> {
        const db = this._firebaseService.db;
        const documentRef = doc(db, `orders/${userId}-${orderNumber}`);

        return setDoc(documentRef, { userId, orderNumber, email, createdAt: new Date(), type: "payment", id_plan: 1 });
    }

    async getMostRecentOrder(userId: string, userEmail: string): Promise<{ id_plan: string; createdAt: Date } | null> {
        const db = this._firebaseService.db;
        const ordersRef = collection(db, "orders");
        const q = query(
            ordersRef,
            and(
                or(
                    where("userId", "==", userId),
                    where("email", "==", userEmail)
                ),
                where("type", "==", "payment")
            ),
            orderBy("createdAt", "desc"),
            limit(1)
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            return null;
        }
        const doc = querySnapshot.docs[0];
        return { id_plan: doc.data().id_plan, createdAt: doc.data().createdAt.toDate() };
    }

    async loadSubscription(userId: string, userEmail: string, proExpDate?: Date): Promise<void> {
        try {
            const db = this._firebaseService.db;
            const ordersRef = collection(db, "orders");
            const q = query(
                ordersRef,
                and(
                    or(
                        where("userId", "==", userId),
                        where("email", "==", userEmail)
                    ),
                    where("type", "==", "payment")
                ),
                orderBy("createdAt", "desc"),
                limit(1)
            );
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const doc = querySnapshot.docs[0];
                this._mostRecentOrder = {
                    id_plan: doc.data().id_plan,
                    createdAt: doc.data().createdAt.toDate()
                };

                if (this._mostRecentOrder.id_plan.toString() === "1") {
                    this._subscriptionType = "lifetime";
                } else if (this._mostRecentOrder.id_plan.toString() === "2412") {
                    this._subscriptionType = "monthly";
                } else if (this._mostRecentOrder.id_plan.toString() === "2367") {
                    this._subscriptionType = "annual";
                } else {
                    this._subscriptionType = null;
                }
            } else if (proExpDate) {
                this._mostRecentOrder = null;
                this._subscriptionType = "special";
            } else {
                this._mostRecentOrder = null;
                this._subscriptionType = null;
            }
        } catch (error) {
            console.error("Error loading subscription:", error);
            this._mostRecentOrder = null;
            this._subscriptionType = null;
        }
    }
}